<template>
  <ion-card>
    <ion-card-content>
    <div id="default-provider">
      <div v-if="provider">
      <div class="provider-title">
        <i class="fal fa-shopping-basket"></i>فروشنده : <b>{{provider.name}}</b>
      </div>
      <hr>
      <div class="provider-point">
        <i class="fal fa-chart-bar"></i>
        امتیاز : {{provider.rate?provider.rate:'--'}} از 5
        امتیاز
      </div>
      <hr>
      <div class="provider-deliver">
        <i class="fal fa-truck-loading"></i>
        مدت زمان تحویل :
        <span v-if="provider.n_deliver_day">
           {{provider.n_deliver_day}}
        روز کاری
        </span>
        <span v-else>
          تحویل فوری
        </span>
      </div>



      <hr/>
      <div id="price_info">
        <div v-if="provider.special_price">
        <div class="special-price">
          <span class="special-price-percent">{{provider.special_price_percent}} %</span>
          <div class="special-price-original-wrapper">
            <del class="special-price-original">
              <money :number="provider.price"></money>
            </del>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="price">
          <span class="amount">
            <money :number="provider.special_price"></money>
          <span class="currency">تومان</span>
          </span>
        </div>
        </div>
        <div v-else class="price">
          <money :number="provider.price"></money>
          <span class="currency">تومان</span>
        </div>
      </div>

      <div v-if="provider.bigger_unit" id="unit_div">
        <label>نوع واحد</label>
        <select @change="changeUnit($event)" autocomplete="off" class="form-control" name="unit" >
          <option value="small">تکی</option>
          <option value="big">{{provider.bigger_unit_title}}</option>
        </select>
        <div class="text-danger">تعداد در هر {{provider.bigger_unit_title}} {{provider.bigger_unit_quantity}} عدد می باشد</div>
        <ion-button :disabled="wait_btn" @click="addToCart" color="success" expand="full" >
          <span v-if="!wait_btn">افزودن به سبد خرید <i class="far fa-shopping-basket"></i></span>
          <i v-else class="far fa-spin fa-spinner"></i>
        </ion-button>
      </div>
      </div>
      <div v-else>
      <div class="body">
        <div id="price_info" class="mb-5">
          تعیین قیمت محصول پس از بررسی توسط کارشناسان ما صورت میگیرد.
        </div>
        <div id="unit_div">
        </div>
        <div class="add_to_cart-container mt-1">
          <div class="row">
            <div class="col-12 p-0">
              <ion-button :disabled="wait_btn" color="success" expand="full" >
                <strong v-if="!wait_btn" @click="addToCart">درخواست تامین کالا</strong>
                <i v-else class="far fa-spin fa-spin"></i>

              </ion-button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    </ion-card-content>
  </ion-card>
</template>

<script>
import Money from "@/components/Money";
export default {
  components:{
    Money
  },
  name: "Seller",
  methods:{

  },
  data:function ()
  {

  },
  watch:{

  },
  mounted()
  {
  },
  props:['provider','productId','changeUnit','addToCart','wait_btn']
}
</script>

<style scoped>
.price
{
  color: #222222;
  font-weight: 800;
  text-align: left;
}
.special-price
{
  text-align: left;
}
.special-price-original-wrapper
{
  display: inline-block;
}
.special-price-percent {
    background: #dc3545;
  border-radius: 10px;
  font-size: 10px;
  padding: 2px;
  color: white;
  margin-left: 5px;
}
ion-card{
  margin: 10px 0 0;
}
</style>